const STORAGE_KEY = 'vatel_accessibility';

export const THEMES = [
  { id: 'classic', label: 'Classique (bleu nuit)' },
  { id: 'high-contrast', label: 'Contraste élevé (N&B)' },
  { id: 'blue', label: 'Bleu accessible' },
  { id: 'green', label: 'Vert accessible' },
  { id: 'amber', label: 'Ambre / chaud' },
];

export const ZOOM_LEVELS = [
  { id: '100', label: '100%', scale: 1 },
  { id: '110', label: '110%', scale: 1.1 },
  { id: '125', label: '125%', scale: 1.25 },
  { id: '150', label: '150%', scale: 1.5 },
];

export const DEFAULT_ACCESSIBILITY = {
  theme: 'classic',
  zoom: '100',
};

export function loadAccessibilityPrefs() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return { ...DEFAULT_ACCESSIBILITY };
    const parsed = JSON.parse(raw);
    return {
      theme: THEMES.some(t => t.id === parsed.theme) ? parsed.theme : DEFAULT_ACCESSIBILITY.theme,
      zoom: ZOOM_LEVELS.some(z => z.id === parsed.zoom) ? parsed.zoom : DEFAULT_ACCESSIBILITY.zoom,
    };
  } catch (e) {
    return { ...DEFAULT_ACCESSIBILITY };
  }
}

export function saveAccessibilityPrefs(prefs) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(prefs));
}

export function applyAccessibilityPrefs(prefs) {
  const root = document.documentElement;
  root.setAttribute('data-theme', prefs.theme || DEFAULT_ACCESSIBILITY.theme);
  const zoom = ZOOM_LEVELS.find(z => z.id === prefs.zoom) || ZOOM_LEVELS[0];
  root.style.setProperty('--app-zoom', String(zoom.scale));
  root.style.fontSize = `${16 * zoom.scale}px`;
}
